var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
define(["require", "exports", "./modules/components/copy", "axios", "./modules/models/viewModels/apiKeyViewModel", "./modules/services/toastNotification", "./modules/components/datePicker", "./modules/components/modal"], function (require, exports, copy_1, axios_1, apiKeyViewModel_1, toastNotification_1, datePicker_1, modal_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    copy_1 = __importDefault(copy_1);
    axios_1 = __importDefault(axios_1);
    apiKeyViewModel_1 = __importDefault(apiKeyViewModel_1);
    datePicker_1 = __importDefault(datePicker_1);
    var ApiKeyHandler = (function () {
        function ApiKeyHandler(dataAdminMemberId, isReadonly, navContainerSelector, options) {
            var _this = this;
            if (isReadonly === void 0) { isReadonly = false; }
            if (navContainerSelector === void 0) { navContainerSelector = '#my-sidenav'; }
            var _a;
            this.basePath = 'api/api-key';
            this.defaultError = 'Ocorreu uma falha ao processar a requisição.';
            this.inputDisabledClassList = ['cursor-not-allowed'];
            this.selectors = {
                txtDescription: '#txt-descricao',
                txtKey: '#txt-chave',
                txtExpiresAt: '#txt-expiracao',
                dataAdminId: '#administradora',
                dataAdminMemberId: '#data-admin-member-id',
                btnOpenNav: '#btn-visualizar-chave',
                btnSaveKeyElement: '#btn-salvar-chave',
                navClose: '#btn-fechar-nav'
            };
            this.SetElementIds = function (options) {
                var txtDescription = options.txtDescription, txtKey = options.txtKey, txtExpiresAt = options.txtExpiresAt, btnSaveKeyElement = options.btnSaveKeyElement, dataAdminId = options.dataAdminId, dataAdminMemberId = options.dataAdminMemberId, btnOpenNav = options.btnOpenNav, navClose = options.navClose;
                _this.selectors.txtDescription = txtDescription !== null && txtDescription !== void 0 ? txtDescription : _this.selectors.txtDescription;
                _this.selectors.txtKey = txtKey !== null && txtKey !== void 0 ? txtKey : _this.selectors.txtKey;
                _this.selectors.txtExpiresAt = txtExpiresAt !== null && txtExpiresAt !== void 0 ? txtExpiresAt : _this.selectors.txtExpiresAt;
                _this.selectors.btnSaveKeyElement = btnSaveKeyElement !== null && btnSaveKeyElement !== void 0 ? btnSaveKeyElement : _this.selectors.btnSaveKeyElement;
                _this.selectors.dataAdminId = dataAdminId !== null && dataAdminId !== void 0 ? dataAdminId : _this.selectors.dataAdminId;
                _this.selectors.dataAdminMemberId = dataAdminMemberId !== null && dataAdminMemberId !== void 0 ? dataAdminMemberId : _this.selectors.dataAdminMemberId;
                _this.selectors.btnOpenNav = btnOpenNav !== null && btnOpenNav !== void 0 ? btnOpenNav : _this.selectors.btnOpenNav;
                _this.selectors.navClose = navClose !== null && navClose !== void 0 ? navClose : _this.selectors.navClose;
                return _this;
            };
            this.OpenNav = function () { return __awaiter(_this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, this.ViewCurrentKey()];
                        case 1:
                            if (!!(_a.sent())) return [3, 3];
                            return [4, this.ViewApiKey()];
                        case 2:
                            _a.sent();
                            _a.label = 3;
                        case 3:
                            this._navContainerElement.style.width = "28%";
                            return [2];
                    }
                });
            }); };
            this.CloseNav = function () {
                _this._navContainerElement.style.width = "0";
            };
            this.ModalConfirmSaveKey = function () { return __awaiter(_this, void 0, void 0, function () {
                var result, modal, callbackFunc;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            result = false;
                            modal = new modal_1.Modal("#main-modal").AddContent("Já existe uma chave cadastrada, ao salvar uma nova chave isso irá invalidar a chave antiga.<br/> Deseja continuar?");
                            callbackFunc = function () {
                                result = true;
                                modal.Close();
                            };
                            modal.AddConfirmButton(callbackFunc);
                            return [4, modal.ShowAsync()];
                        case 1:
                            _a.sent();
                            return [2, result];
                    }
                });
            }); };
            this.ConfirmSaveKey = function () { return __awaiter(_this, void 0, void 0, function () {
                var apiKey;
                var _a;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0: return [4, this.GetApiKey()];
                        case 1:
                            apiKey = (_a = (_b.sent())) === null || _a === void 0 ? void 0 : _a.data.data;
                            if (!apiKey)
                                return [2, true];
                            return [4, this.ModalConfirmSaveKey()];
                        case 2: return [2, _b.sent()];
                    }
                });
            }); };
            this.SaveKey = function () { return __awaiter(_this, void 0, void 0, function () {
                var apiKeyViewModel;
                var _this = this;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!this._txtDescriptionElement.value || !this._txtKeyElement.value || !this._txtExpiresAtElement) {
                                toastNotification_1.ToastNotification.Error('Preencha todos os campos para cadastrar uma chave');
                                return [2, this];
                            }
                            return [4, this.ConfirmSaveKey()];
                        case 1:
                            if (!(_a.sent()))
                                return [2];
                            apiKeyViewModel = new apiKeyViewModel_1.default(0, null, this._dataAdminMemberId, this._txtDescriptionElement.value, this._txtKeyElement.value, this._txtExpiresAtElement.value, false, true);
                            apiKeyViewModel.dataAdministratorMemberId = Number(document.querySelector(this.selectors.dataAdminMemberId).value);
                            return [4, this.PostApiKey(apiKeyViewModel).then(function (response) {
                                    toastNotification_1.ToastNotification.Success('Chave cadastrada com sucesso.');
                                })
                                    .catch(function (error) {
                                    var _a, _b, _c;
                                    toastNotification_1.ToastNotification.Error((_c = (_b = (_a = error === null || error === void 0 ? void 0 : error.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.data) !== null && _c !== void 0 ? _c : _this.defaultError);
                                })];
                        case 2:
                            _a.sent();
                            return [2];
                    }
                });
            }); };
            this.PostApiKey = function (apiKeyViewModel) { return __awaiter(_this, void 0, void 0, function () {
                var url;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            url = encodeURI(this.basePath + "/gerar");
                            return [4, axios_1.default.post(url, apiKeyViewModel)];
                        case 1: return [2, _a.sent()];
                    }
                });
            }); };
            this.GetApiKey = function () { return __awaiter(_this, void 0, void 0, function () {
                var dataAdminMemberId, url;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            dataAdminMemberId = document.querySelector(this.selectors.dataAdminMemberId).value;
                            if (!dataAdminMemberId)
                                return [2];
                            url = encodeURI(this.basePath + "/obter-chave?idBandeira=" + (dataAdminMemberId !== null && dataAdminMemberId !== void 0 ? dataAdminMemberId : ''));
                            return [4, axios_1.default.get(url)];
                        case 1: return [2, _a.sent()];
                    }
                });
            }); };
            this.NewKey = function () { return __awaiter(_this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, axios_1.default.get(this.basePath + "/nova")];
                        case 1: return [2, _a.sent()];
                    }
                });
            }); };
            this.GetExpiration = function () { return __awaiter(_this, void 0, void 0, function () {
                var _this = this;
                return __generator(this, function (_a) {
                    axios_1.default.get(this.basePath + "/expiracao").then(function (response) {
                        _this._expirationDate = new Date(response.data.data);
                        _this._expirationDarePicker.SetDate(_this._expirationDate);
                    });
                    return [2];
                });
            }); };
            this.ViewApiKey = function () { return __awaiter(_this, void 0, void 0, function () {
                var _a;
                var _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0:
                            this._expirationDarePicker.SetDate(this._expirationDate);
                            this._txtDescriptionElement.value = '';
                            _a = this._txtKeyElement;
                            return [4, this.NewKey()];
                        case 1:
                            _a.value = (_c = (_b = (_d.sent()).data.data) === null || _b === void 0 ? void 0 : _b.toString()) !== null && _c !== void 0 ? _c : '';
                            this.UpdateCopyButton();
                            return [2];
                    }
                });
            }); };
            this.ViewCurrentKey = function () { return __awaiter(_this, void 0, void 0, function () {
                var apiKey;
                var _a;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0: return [4, this.GetApiKey()];
                        case 1:
                            apiKey = (_a = (_b.sent())) === null || _a === void 0 ? void 0 : _a.data.data;
                            if (!apiKey)
                                return [2, false];
                            this._expirationDarePicker.SetDate(new Date(apiKey.expiresAt));
                            this._txtDescriptionElement.value = apiKey.description;
                            this._txtKeyElement.value = apiKey.value;
                            this.UpdateCopyButton();
                            return [2, true];
                    }
                });
            }); };
            this.AddCopyButton = function () {
                _this._txtKeyElement.addEventListener('input', function () { return _this.UpdateCopyButton(); });
            };
            this.UpdateCopyButton = function () {
                var _a, _b;
                (_a = document.querySelectorAll('.copy-container')) === null || _a === void 0 ? void 0 : _a.forEach(function (element, key) {
                    element.innerHTML = new copy_1.default(_this._txtKeyElement.value).Create("Chave");
                });
                (_b = document.querySelectorAll('.copy-button')) === null || _b === void 0 ? void 0 : _b.forEach(function (element, key) {
                    copy_1.default.AddEventHandler(element, false);
                });
            };
            if (options)
                this.SetElementIds(options);
            this._dataAdminMemberId = dataAdminMemberId;
            this._isReadOnly = isReadonly;
            var navContainerElement = document.querySelector(navContainerSelector);
            var btnNavCloseElement = navContainerElement === null || navContainerElement === void 0 ? void 0 : navContainerElement.querySelector(this.selectors.navClose);
            var txtDescriptionElement = navContainerElement === null || navContainerElement === void 0 ? void 0 : navContainerElement.querySelector(this.selectors.txtDescription);
            var txtKeyElement = navContainerElement === null || navContainerElement === void 0 ? void 0 : navContainerElement.querySelector(this.selectors.txtKey);
            var txtExpiresAtElement = navContainerElement === null || navContainerElement === void 0 ? void 0 : navContainerElement.querySelector(this.selectors.txtExpiresAt);
            var btnSaveKeyElement = navContainerElement === null || navContainerElement === void 0 ? void 0 : navContainerElement.querySelector(this.selectors.btnSaveKeyElement);
            if (!navContainerElement || !btnNavCloseElement)
                throw new Error('Barra lateral não foi configurada corretamente.');
            this._navContainerElement = navContainerElement;
            this._navCloseElement = btnNavCloseElement;
            this._txtDescriptionElement = txtDescriptionElement;
            this._txtKeyElement = txtKeyElement;
            this._txtExpiresAtElement = txtExpiresAtElement;
            this._btnSaveKeyElement = btnSaveKeyElement;
            this.GetExpiration();
            this._expirationDarePicker = new datePicker_1.default(this._txtExpiresAtElement);
            this._expirationDarePicker.CreateWithConfig("auto left");
            this._expirationDarePicker.SetMinDate();
            this.AddCopyButton();
            this._btnSaveKeyElement.addEventListener('click', this.SaveKey);
            (_a = document.querySelector(this.selectors.btnOpenNav)) === null || _a === void 0 ? void 0 : _a.addEventListener('click', this.OpenNav);
            this._navCloseElement.addEventListener('click', this.CloseNav);
        }
        return ApiKeyHandler;
    }());
    exports.default = ApiKeyHandler;
});
